export default __webpack_public_path__ + "static/photo-15-e98e9d4c3032bee17bcf8be85edc3216.jpg";